import { isAutomatedBrowser } from '@/lib/automation';

/**
 * Whether to mount the development-only devtools panels.
 *
 * They belong to a person debugging, not to the app, and the end-to-end suite drives the same
 * dev server a person does, so `import.meta.env.DEV` alone puts them in front of it: the
 * router panel's launcher sits bottom-right, over the footer of every drawer, and intercepts
 * the clicks a test aims at Save or Delete.
 */
export function showDevChrome(): boolean {
    if (!import.meta.env.DEV) return false;
    return !isAutomatedBrowser();
}
